import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useLocalization } from 'contexts/LocalizationContext.jsx';
import { useTooltipContext } from 'contexts/TooltipContext.jsx';
import constants from 'constants/tooltips.js';
import StepTooltip from 'components-v3/StepTooltip/index.jsx';
import { ON_DEMAND_PRODUCT } from 'constants/products.js';

const OnDemandProductSwitcherTooltip = ({
  selectedProduct,
  goTo,
  closeProductHeader,
  children,
}) => {
  const { t } = useLocalization();
  const { pathname } = useLocation();

  const { isTooltipVisible } = useTooltipContext();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const canShowTooltip = selectedProduct !== ON_DEMAND_PRODUCT;
    setIsVisible(canShowTooltip
      && isTooltipVisible(constants.ONE_DEMAND));
  }, [pathname, isTooltipVisible, selectedProduct]);

  const goToGetStarted = () => goTo();

  const previousStep = () => closeProductHeader();

  return (
    <StepTooltip
      title={t('genericLabels.onDemandProductSwitcherTooltipTitle')}
      description={t('genericLabels.onDemandProductSwitcherTooltipDescription')}
      tooltipKey={constants.ONE_DEMAND}
      step={2}
      maxSteps={2}
      variant="orange"
      onLast={goToGetStarted}
      onPrevious={previousStep}
      isShown={isVisible}
      minWidth="400px"
      style={{
        zIndex: 4,
      }}
      tooltipPosition="bottom"
    >
      {children}
    </StepTooltip>
  );
};

export default OnDemandProductSwitcherTooltip;
